var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 24 24",
    id: "Ecology-Wood-Plant-Grow--Streamline-Pixel.svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Ecology Wood Plant Grow Streamline Icon: https://streamlinehq.com")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ecology-wood-plant-grow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.8078125 21.3540625H23v1.0996875h-2.1921874999999997Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8078125 18.069375h1.0996875v1.0996875h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7153125 20.2615625h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.8078125 18.069375 0 -1.0925 -1.0925 0 0 -7.6690625 -1.0996875 0 0 4.3843749999999995 -1.0925 0 0 1.0925 1.0925 0 0 5.476875 1.0996875 0 0 -2.1921874999999997 1.0925 0z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.523125 8.2153125h1.0925v1.0925h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.430625 10.4075h1.0925v2.185h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3309375 7.1156250000000005h2.1921874999999997v1.0996875h-2.1921874999999997Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.476875 14.7846875h12.04625v1.0925H5.476875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3309375 9.307812499999999h1.0996875v1.0996875h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.569375000000001 12.5925h9.86125v1.0996875H6.569375000000001Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.138750000000002 21.3540625h1.0996875v1.0996875h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.138750000000002 18.069375h1.0996875v2.1921874999999997h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.04625 10.4075h2.1921874999999997V11.5h-2.1921874999999997Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.854062500000001 16.976875h1.0996875v4.3771875h-1.0996875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7615625 21.3540625h1.0925v1.0996875h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.854062500000001 7.1156250000000005V11.5h1.0996875V7.1156250000000005h3.2846875000000004V6.023125h1.0925V4.930625h1.0996875V3.8309375h1.0925V0.54625h-4.3843749999999995v1.0996875h-1.0925v1.0925h-1.0925v1.0925h-1.0996875v2.1921874999999997h-1.0925V7.1156250000000005Zm2.1921874999999997 -3.2846875000000004h1.0925V2.7384375h1.0996875V1.6459375h1.0925v1.0925h-1.0925v1.0925h-1.0996875v1.0996875h-1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.569375000000001 9.307812499999999h2.1921874999999997v1.0996875H6.569375000000001Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.569375000000001 18.069375h1.0996875v2.1921874999999997H6.569375000000001Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.476875 7.1156250000000005h2.1921874999999997v1.0996875H5.476875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.476875 10.4075h1.0925v2.185H5.476875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.3771875 13.692187500000001 0 -4.3843749999999995 -1.0925 0 0 8.7615625 -2.1921874999999997 0 0 1.0996875 2.1921874999999997 0 0 1.0925 1.0925 0 0 -5.476875 1.0996875 0 0 -1.0925 -1.0996875 0z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3771875 8.2153125h1.0996875v1.0925H4.3771875Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.3771875 1.6459375 0 3.2846875000000004 1.0996875 0 0 1.0925 3.2846875000000004 0 0 -2.1921874999999997 -2.1921874999999997 0 0 -1.0925 -1.0925 0 0 -1.0925 -1.0996875 0z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1921874999999997 20.2615625h1.0925v1.0925H2.1921874999999997Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0925 21.3540625h1.0996875v1.0996875H1.0925Z",
    fill: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.976875h1.0925v1.0925H0Z",
    fill: "#000000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.a3e320434c7c052d7bbf3264d6e0cc77.svg";
export { ForwardRef as ReactComponent };